import React, { useEffect } from "react";
import { TableFinancialBalance } from "../../components";
import { getAllDebt, selectAllPayment } from "../../store/slices/debtSlice";
import { useDispatch, useSelector } from "react-redux";
import qarkullimi from "../../../src/assets/qarkullimi.png";
import fitimi from "../../../src/assets/fitimi.png";
import pagesat from "../../../src/assets/pagesat.png";
import pagesatBankes from "../../../src/assets/pagesatBankes.png";
import fitimiKartelat from "../../../src/assets/fitimiKartelat.png";
import mosbarazimi from "../../../src/assets/mosbarazimi.png";

const FinancialBalance = () => {
  const dispatch = useDispatch();
  const paymentData = useSelector(selectAllPayment);
  const allDebt = useSelector((state) => state.debt.allDebt);
  const fetchDebt = useSelector((state) => state.debt.data);
  console.log("🚀 ~ FinancialBalance ~ fetchDebt:", fetchDebt);
  const payDebtStatus = useSelector((state) => state.debt.payDebtStatus);
  const loadingReset = useSelector((state) => state.debt.loadingResetPay);

  useEffect(() => {
    dispatch(getAllDebt());
  }, [payDebtStatus, loadingReset]);

  const Card = ({ icon, label, value, bg }) => (
    <div className="w-full sm:w-[47%] lg:w-[30%] xl:w-[280px]">
      <div className="hidden sm:flex items-center bg-white shadow-md rounded-2xl p-4">
        <div className={`rounded-full p-3 mr-4 ${bg}`}>
          <img src={icon} alt={label} className="w-6 h-6" />
        </div>
        <div>
          <p className="text-[#718EBF] text-sm">{label}</p>
          <p className="text-black text-lg font-bold whitespace-nowrap">
            {value}€
          </p>
        </div>
      </div>

      <div className="sm:hidden bg-white shadow-md rounded-2xl p-4 flex flex-col items-start gap-3">
        <div className={`rounded-full p-3 ${bg}`}>
          <img src={icon} alt={label} className="w-6 h-6" />
        </div>
        <div>
          <p className="text-[#718EBF] text-xs font-medium whitespace-nowrap">
            {label}
          </p>
          <p className="text-black text-lg font-bold whitespace-nowrap">
            {value}€
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="pt-12 px-2 sm:px-4 lg:px-6 w-full">
      <div className="grid grid-cols-2 sm:flex sm:flex-wrap justify-center gap-4 w-full">
        <Card
          icon={qarkullimi}
          label="Qarkullimi"
          value={fetchDebt?.totals?.qarkullimi}
          bg="bg-[#FFF5D9]"
        />
        <Card
          icon={fitimi}
          label="Fitimi i autoshkollave"
          value={fetchDebt?.totals?.fitimi}
          bg="bg-[#F5CBC9]"
        />
        <Card
          icon={pagesat}
          label="Pagesat"
          value={fetchDebt?.totals?.pagesat_cash}
          bg="bg-[#CFEDD2]"
        />
        <Card
          icon={pagesatBankes}
          label="Pagesat e bankes"
          value={fetchDebt?.totals?.pagesat_bankes}
          bg="bg-[#CFEDD2]"
        />
        <Card
          icon={fitimiKartelat}
          label="Fitimi nga kartelat"
          value={fetchDebt?.totals?.qarkullimi}
          bg="bg-[#FFE9BE]"
        />
        <Card
          icon={mosbarazimi}
          label="Mosbarazimi"
          value={fetchDebt?.totals?.mosbarazimi}
          bg="bg-[#F5CBC9]"
        />
      </div>

      <div className="m-2 md:m-6 p-2 md:p-6 bg-white rounded-3xl">
        <p className="text-xl mb-4 text-left font-semibold">Barazimi</p>
        <TableFinancialBalance />
      </div>
    </div>
  );
};

export default FinancialBalance;
